import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { GenericPageLayout } from '@layout/GenericPageLayout';
import { Head } from '@components/common/head';
import { Error500 } from '@components/common/hero/error/Error500';
import { useI18NextContext } from '@components/hooks';
import { getDestinationMetaDescription, getDestinationMetaTitle } from '@model/meta/destination-meta';
import { ERROR_CODES } from '@model/common/error-codes';
import { setPartialSearch } from '@state/deal-finder/dealFinderOperations';
import { Logging } from '@util/logging';
import { getDestinationSearchParams, DestinationSearchParams } from '@util/destination';
import { DestinationPageHolidaysLayoutProps } from './props';

export const DestinationPageHolidaysLayout = ({
  path,
  pageConfig,
  componentsData,
  destination,
  tripType,
  promoBannerTripType
}: DestinationPageHolidaysLayoutProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (destination) {
      const { display } = destination;
      const defaultSearchParams = getDestinationSearchParams({
        display,
        path
      } as DestinationSearchParams);
      dispatch(setPartialSearch(defaultSearchParams));
    }
  }, [path]);

  if (!pageConfig) {
    Logging.warn({ text: `No pageConfig for ${path} ${tripType}` });
    return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;
  }
  if (!destination) {
    Logging.warn({ text: `No destination for ${path} ${tripType}` });
    return <Error500 code={ERROR_CODES.NO_API_DESTINATION} />;
  }

  const { components } = pageConfig;

  const t: any = useI18NextContext();
  const metaTitle = getDestinationMetaTitle(destination, tripType, t);
  const metaDescription = getDestinationMetaDescription(destination, tripType, t);

  return (
    <>
      <Head metaTitle={metaTitle} metaDescription={metaDescription} />
      <GenericPageLayout
        components={components}
        componentsData={componentsData}
        tripType={tripType}
        path={path}
        destination={destination}
        promoBannerTripType={promoBannerTripType}
      />
    </>
  );
};
